"use strict";

(function(z){

    z.ProjectsCorporateContractsForm = z.FormView.extend({
        el:"#corporate_contracts_form-modal",

        events: function() {

            return _.extend({}, z.FormView.prototype.events,{
                "click #corporate_contracts_form-save-button": "_onSubmitForm",
                "change #corporate_contractsform-county-field": "_onCountyChange",
                "click #corporateContractsRepresentativeForm-add-button": "_onCreateContractsRepresentative",
                "click #corporateContractsClientsRepresentativeForm-add-button": "_onCreateContractsClientRepresentative",
                "click .edit-representative-form" : "_onEditRepresentativeForm",
                "click .delete-representative-form" : "_onDeleteRepresentativeRow",
                "click .edit-client-representative-form" : "_onEditClientRepresentativeForm",
                "click .delete-client-representative-form" : "_onDeleteClientRepresentativeRow"
            });
        },

        /**
         * Constructor.
         *
         * @return {undefined}
         */
        initialize: function() {

            z.FormView.prototype.initialize.apply(this, arguments);

            // Initializing Backbone Validation Library
            this._bindValidation();

            this.representativesContractsCollection = new z.ProjectsRepresentativesContractsCollection();

            this.listenTo(this.representativesContractsCollection, 'add', this._onRepresentativesContractsCollectionAdd);
            this.listenTo(this.representativesContractsCollection, 'remove', this._onRepresentativesContractsCollectionRemove);
            this.listenTo(this.representativesContractsCollection, 'reset', this._onRepresentativesContractsCollectionReset);
            this.listenTo(this.representativesContractsCollection, 'change', this._onRepresentativesContractsCollectionChange);

            this.representativesClientContractsCollection = new z.ProjectsRepresentativesClientContractsCollection();

            this.listenTo(this.representativesClientContractsCollection, 'add', this._onRepresentativesClientContractsCollectionAdd);
            this.listenTo(this.representativesClientContractsCollection, 'remove', this._onRepresentativesClientContractsCollectionRemove);
            this.listenTo(this.representativesClientContractsCollection, 'reset', this._onRepresentativesClientContractsCollectionReset);
            this.listenTo(this.representativesClientContractsCollection, 'change', this._onRepresentativesClientContractsCollectionChange);

            var path = window.location.pathname;
            var match = path.match(/client\/(\d+)/);
            this.defaultClientId = (match && match[1]) ? match[1] : null;
        },

        /**
         * Method that renders the form
         *
         * @return {Object} - this object
         */
        render: function() {

            // Clean up the form
            this._cleanupForm();

            z.FormView.prototype.render.apply(this, arguments);

            // Initialize the chosen fields
            // this._initializeChosen();

            var title = this.getModalFormEditTitleText();

            var addTitle = this.getModalFormAddTitleText();
            if (this.$el.find('.modal-title').text() === addTitle && this.defaultClientId) {
                this.$('#corporate_contractsform_clientId-field').val(this.defaultClientId);
                this.$('#corporate_contractsform_clientId-field').trigger('chosen:updated');
            }


            return this;
        },

        /**
         * Get add entity route name.
         *
         * @return {string} - add entity route name
         */
        getAddEntityRouteName: function() {
            return 'addCorporateContracts';
        },

        /**
         * Get edit entity route name.
         *
         * @return {string} - edit entity route name
         */
        getEditEntityRouteName: function() {
            return 'editCorporateContracts';
        },

        /**
         * Get modal form add title text
         *
         * @return {string} - modal form add title text
         */
        getModalFormAddTitleText: function() {
            return Translator.trans('js.btn_add_corporate_contracts');
        },

        /**
         * Get modal form edit title text
         *
         * @return {string} - modal form edit title text
         */
        getModalFormEditTitleText: function() {
            return Translator.trans('js.btn_edit_corporate_contracts');
        },

        /**
         * Get error panel container id.
         *
         * @return {string} - the error panel id
         */
        getErrorPanelId: function() {
            return '#corporate_contracts_form-error-panel';
        },

        /**
         * Get submit button selector.
         *
         * @return {string} - the submit button selector
         */
        getSubmitButtonSelector: function() {
            return '#corporate_contracts_form-save-button';
        },

        /**
         * Get page path.
         *
         * @return {string} - the page path
         */
        getPagePath: function() {
            return 'corporate_contracts';
        },

        /**
         * Get success event name.
         *
         * @return {string} - the success event name
         */
        getSuccessEventName: function() {
            return 'corporate_contracts.success';
        },

        /**
         * Get form error message text.
         *
         * @return {string} - form error message text
         */
        getFormErrorMessageText: function() {
            return Translator.trans('js.error_message_corporate_contracts_form');
        },


        /**
         * Collecting data from form inputs.
         *
         * @private
         * @return {Object}
         */
        getFormData: function() {

            // Get the fields
            var $nameField     = this.$('#corporate_contractsform-name-field');
            var $incomeCenter   = this.$('#corporate_contractsform-incomeCenter-field');
            var $contractDateStartAt   = this.$('#corporate_contractsform-contractDateStartAt-field');
            var $contractDateEndAt = this.$('#corporate_contractsform-contractDateEndAt-field');
            var $paymentTermField = this.$('#corporate_contractsform-paymentTerm-field');
            var $deliveryTermField   = this.$('#corporate_contractsform-deliveryTerm-field');
            var $warrantyTermField   = this.$('#corporate_contractsform-warrantyTerm-field');
            var $slaResponseField   = this.$('#corporate_contractsform-slaResponse-field');
            var $slaInterventionField   = this.$('#corporate_contractsform-slaIntervention-field');
            var $slaSolutionField   = this.$('#corporate_contractsform-slaSolution-field');
            var $valueField   = this.$('#corporate_contractsform-value-field');
            var $invoiceDetails   = this.$('#corporate_contractsform-invoiceDetails-field');
            var $statusField   = this.$('#corporate_contractsform-status-field');
            var $clientId = this.$('#corporate_contractsform_clientId-field');

            return {
                'clientId' : $clientId.val(),
                'name'     : $nameField.val(),
                'incomeCenter'   : $incomeCenter.val(),
                'contractDateStartAt'   : $contractDateStartAt.val(),
                'contractDateEndAt'   : $contractDateEndAt.val(),
                'paymentTerm'   : $paymentTermField.val(),
                'deliveryTerm'   : $deliveryTermField.val(),
                'warrantyTerm'   : $warrantyTermField.val(),
                'slaResponse': $slaResponseField.val(),
                'slaIntervention': $slaInterventionField.val(),
                'slaSolution'   : $slaSolutionField.val(),
                'value'   : $valueField.val(),
                'invoiceDetails'   : $invoiceDetails.val(),
                'status'   : $statusField.val()
            };
        },

        /**
         * Method used to show a general error message if the user is
         * browsing the app on mobile
         *
         * @return {undefined}
         */
        showMobileAlert: function()
        {
            var errorMessage = Translator.trans('js.corporate_contracts_create_error_message_mobile');

            // Display mobile alert
            this.$el.find('#corporate_contracts-create-general-error-panel')
                .removeClass('hidden')
                .text(errorMessage)
                .fadeTo('slow', 1)
                .delay(3000)
                .fadeTo('slow', 0, function(){
                    this.hideMobileAlert();
                }.bind(this));
        },

        _isLoading: function (loading, $btn) {

            loading = loading ? loading : _.isUndefined(loading);

            if (typeof $btn === 'string') {
                $btn = $($btn);
            }

            var ladda = $btn.data('ladda') ? $btn.data('ladda') : $btn.ladda().data('ladda');

            if (loading) {
                ladda.start();
            } else {
                ladda.stop();
            }
        },

        /**
         * Method used to hide the error message if the form is submitted, or the modal has been closed
         *
         * @return {undefined}
         */
        hideMobileAlert: function()
        {
            this.$el.find('#corporate_contracts-create-general-error-panel').addClass('hidden');
        },

        /**
         * Method that resets the form fields, resets the collections and
         * hides the tables holding data
         *
         * @private
         * @return {undefined}
         */
        _cleanupForm: function() {

            // Resetting form
            this._resetFields("corporate_contracts_form");

            // Resetting collections
            this.representativesContractsCollection.reset();
            this.representativesClientContractsCollection.reset();

            // Resetting edit IDs
            this.representativeEditAddId = undefined;
            this.clientRepresentativeEditAddId = undefined;
        },

        /**
         * Method that hides the wrapper that holds the table
         *
         * @param {Object} $wrapperName - the div object that acts as a wrapper
         * @private
         * @return {undefined}
         */
        _hideWrapper: function($wrapperName) {

            $wrapperName.addClass("hidden");
        },


        /**
         * Method that resets the specified fields according to id passed
         *
         * @param {string} value Name of the id to search for
         * @private
         * @return {undefined}
         */
        _resetFields: function (value) {

            this.$('[id^=' + value + ']').val("");
        },

        /**
         * Method that fills in the tables with the representative data
         *
         * @param {object} model - The representative model
         * @private
         * @return {undefined}
         */
        _fillRepresentativesForm: function(model) {
            // Getting data from model
            var data = model.attributes.representatives;

            if (!data) {
                return;
            }

            // Showing table
            var $wrapperName = this.$('.representative-list');
            this._displayWrapper($wrapperName);

            // Pushing data in collection
            Object.keys(data).forEach(function(key) {

                var representative = {
                    name: data[key].name,
                    position: data[key].position,
                    phoneNumber: data[key].phoneNumber,
                    email: data[key].email
                };

                this.representativesContractsCollection.push(representative);
            }.bind(this));
        },


        /**
         * Method that fills in the tables with the client representative data
         *
         * @param {object} model - The representative model
         * @private
         * @return {undefined}
         */
        _fillClientRepresentativesForm: function(model) {
            // Getting data from model
            var data = model.attributes.representativesClients;

            if (!data) {
                return;
            }

            // Showing table
            var $wrapperName = this.$('.representativeClients-list');
            this._displayWrapper($wrapperName);

            // Pushing data in collection
            Object.keys(data).forEach(function(key) {

                var representative = {
                    name: data[key].name,
                    position: data[key].position,
                    phoneNumber: data[key].phoneNumber,
                    email: data[key].email
                };

                this.representativesClientContractsCollection.push(representative);
            }.bind(this));
        },


        _isValidRepresentatives: function() {
            if (this.representativesContractsCollection.size() > 0 || this.representativesClientContractsCollection.size() > 0) {
                this.$('.representative-validation-error').addClass('hidden');
                return true;
            } else {
                var errorValidationRepresentative = Translator.trans('js.error_validation_representative');
                this.$('.representative-validation-error').removeClass("hidden").text(errorValidationRepresentative);
                return false;
            }
        },

        /**
         * Method that fills the form input fields with data coming from the model.
         * It is used when the form is being edited.
         *
         * @private
         * @return {undefined}
         */
        _fillForm: function() {
            this._fillRepresentativesForm(this.model);
            this._fillClientRepresentativesForm(this.model);
            var map = {
                "corporate_contractsform_clientId-field": "clientId",
                "corporate_contractsform-name-field": "name",
                "corporate_contractsform-incomeCenter-field": "incomeCenter",
                "corporate_contractsform-contractDateStartAt-field": "contractDateStartAt",
                "corporate_contractsform-contractDateEndAt-field": "contractDateEndAt",
                "corporate_contractsform-paymentTerm-field": "paymentTerm",
                "corporate_contractsform-deliveryTerm-field": "deliveryTerm",
                "corporate_contractsform-warrantyTerm-field": "warrantyTerm",
                "corporate_contractsform-slaResponse-field": "slaResponse",
                "corporate_contractsform-slaIntervention-field": "slaIntervention",
                "corporate_contractsform-slaSolution-field": "slaSolution",
                "corporate_contractsform-value-field": "value",
                "corporate_contractsform-invoiceDetails-field": "invoiceDetails",
                "corporate_contractsform-status-field": "status"
            };

            Object.keys(map).forEach(function(key){

                var value = this.model.get(map[key]);

                if (value !== null && value !== undefined && typeof value === "object") {
                    // relație Backbone/Obiect — extrage .id
                    this.$el.find("#" + key).val(value.id);
                } else {
                    // valoare simplă (string, number, boolean)
                    this.$el.find("#" + key).val(value);
                }

            }.bind(this));

            var dateFields = [
                'corporate_contractsform-contractDateStartAt-field',
                'corporate_contractsform-contractDateEndAt-field'
            ];

            dateFields.forEach(function(fieldId) {
                var rawValue = this.model.get(map[fieldId]);

                if (rawValue && typeof rawValue === 'string') {
                    var date = new Date(rawValue);
                    if (!isNaN(date.getTime())) {
                        var day   = ('0' + date.getDate()).slice(-2);
                        var month = ('0' + (date.getMonth() + 1)).slice(-2);
                        var year  = date.getFullYear();
                        // var hours = ('0' + date.getHours()).slice(-2);
                        // var mins  = ('0' + date.getMinutes()).slice(-2);
                        // var secs  = ('0' + date.getSeconds()).slice(-2);

                        this.$el.find('#' + fieldId).val(
                            day + '-' + month + '-' + year
                        );
                    }
                }
            }.bind(this));
        },

        /**
         * Method that binds validation to the chosen model
         *
         * @param {object} model The model that the validation is being performend on
         * @private
         * @return {undefined}
         */
        _bindValidation: function(model) {

            model = _.isUndefined(model) ? this.model : model;
            Backbone.Validation.unbind(this, {model: model});

            Backbone.Validation.bind(this, {
                valid: this._onValid.bind(this),
                invalid: this._onInvalid.bind(this),
                model: model
            });
        },

        /**
         * Display the error message
         *
         * @param {string} message The message to be shown
         * @private
         * @return {undefined}
         */
        _showError: function(message) {
            // TODO: move in abstract class to be reused

            var errorMessage = Translator.trans('js.corporate_contracts_create_error_message_mobile');

            // Display mobile alert
            this.$el.find('#corporate_contracts-create-general-error-panel')
                .removeClass('hidden')
                .text(message)
                .fadeTo('slow', 1)
                .delay(3000)
                .fadeTo('slow', 0, function(){
                    this.hideMobileAlert();
                }.bind(this));
        },

        _displayError: function(res){
            console.log(res.responseJSON);
            var errors = res.responseJSON.errors;

            if (errors.length !== 0) {

                var message = errors;

                if (typeof res.responseJSON != "undefined")
                {
                    this._showError(message);
                }
            }
        },

        /**
         * Method that handles the form submission
         *
         * @param {Event} e - the event
         * @return {undefined}
         * @private
         */
        _onSubmitForm: function (e) {

            e.preventDefault();

            // Get form data
            var formData = this.getFormData();
            this.model.set(formData);

            // 1. Validează câmpurile formularului MAI ÎNTÂI
            var isValid = this.model.isValid(true);

            if (!isValid) {
                this.showMobileAlert();
                return;
            }

            // 2. Abia apoi verifică reprezentanții
            var hasRepresentatives = this._isValidRepresentatives();

            if (!hasRepresentatives) {
                return;
            }

            // 3. Ascunde eroarea de reprezentant și continuă
            this.$('.representative-validation-error').addClass('hidden');

            this._isLoading(true, this.getSubmitButtonSelector());
            this._addRepresentativesModel(this.model);
            // Save the model
            this.model.save(null, {

                success: function (i) {

                    if (this.defaultClientId) {

                        window.location.href = Routing.generate('show_client_corporate_contracts', {
                            clientId: this.defaultClientId
                        });
                    } else {

                        this.model.trigger("success", i);
                    }
                }.bind(this),
                error: function(model, res) {
                    this._displayError(res);
                    this._isLoading(false, this.getSubmitButtonSelector());
                }.bind(this)
            });
        },

        /**
         * Method that iterates through the localities
         * returned from php and sets them as options in the
         * locality select
         *
         * @param {object} localities The loclaities corresponding to the county
         * @private
         * @return {undefined}
         */
        _setLocalityOptions: function (localities) {
            for (var index in localities) {
                var opt = document.createElement("option");
                opt.value = localities[index].id;
                opt.innerHTML = localities[index].name;
                this.$('#corporate_contractsform-locality-field').append(opt);
            }
        },

        /**
         * Method that makes the request to get the data
         * for the localities select
         *
         * @private
         * @return {undefined}
         */
        _onCountyChange: function () {
            // Get the county id
            var id = this.$("#corporate_contractsform-county-field option:selected").val();

            this.localitiesCollection.reset(null);

            if (id) {

                this.localitiesCollection.setCountyId(id);

                // Get the localities collection for the given county
                this.localitiesCollection.fetch({
                    success: function() {
                        this.$('#corporate_contractsform-locality-field').trigger("chosen:updated");
                        this.$("#corporate_contractsform-locality-field").trigger('load');
                    }.bind(this)
                });

            } else {

                this.$('#corporate_contractsform-locality-field').trigger("chosen:updated");
            }
        },

        /**
         * Method triggered on the locality collection add
         *
         * @param {object} model - Model binded to the collection
         * @private
         * @return {undefined}
         */
        _onLocalitiesCollectionAdd: function(model){
            this._renderLocality(model);
        },

        /**
         * Method triggered on the locality collection reset
         *
         * @private
         * @return {undefined}
         */
        _onLocalitiesCollectionReset: function(){
            this._renderLocalityReset();
        },

        /**
         * Method that renders the locality select
         *
         * @param {object} model - Model binded to the collection
         * @private
         * @return {undefined}
         */
        _renderLocality: function(model){
            var $option = $('<option>').attr('value', model.get('id')).text(model.get('name'));
            this.$('#corporate_contractsform-locality-field').append($option);
        },

        /**
         * Method that resets the locality select
         *
         * @private
         * @return {undefined}
         */
        _renderLocalityReset: function(){
            var $option = this.$("#corporate_contractsform-locality-field option:eq(0)").detach();
            this.$('#corporate_contractsform-locality-field').empty().append($option);
        },

        /**
         * Method that returns the text for the selected option
         *
         * @private
         * @return {*|jQuery} - Text for the selected county field option
         */
        _getCountyValue: function () {
            return this.$('#worksiteform-county-field').find("option:selected").text();
        },

        /**
         * Method that returns the text for the selected option
         *
         * @private
         * @return {*|jQuery} - Text for the selected locality field option
         */
        _getLocalityValue: function () {
            return this.$('#worksiteform-locality-field').find("option:selected").text();
        },

        /**
         * Method that returns the text for the selected option
         *
         * @private
         * @return {*|jQuery} - Text for the selected status field option
         */
        _getStatusValue: function () {
            return this.$('#worksiteform-status-field').find("option:selected").text();
        },

        // =====================================================================
        //  CONTRACT REPRESENTATIVES DATA
        // =====================================================================

        _getContractRepresentativesData: function() {
            var $name = this.$('#corporateContractsRepresentativeForm-name-field');
            var $position = this.$('#corporateContractsRepresentativeForm-position-field');
            var $phone = this.$('#corporateContractsRepresentativeForm-phoneNumber-field');
            var $status = this.$('#corporateContractsRepresentativeForm-status-field');
            var $email = this.$('#corporateContractsRepresentativeForm-email-field');

            return {
                'name': $name.val(),
                'position': $position.val(),
                'phone': $phone.val(),
                'status': $status.val(),
                'email': $email.val(),
            };
        },

        // =====================================================================
        //  CLIENT CONTRACT REPRESENTATIVES DATA
        // =====================================================================

        _getClientContractRepresentativesData: function() {
            var $name = this.$('#corporateContractsClientsRepresentativeForm-name-field');
            var $position = this.$('#corporateContractsClientsRepresentativeForm-position-field');
            var $phone = this.$('#corporateContractsClientsRepresentativeForm-phoneNumber-field');
            var $status = this.$('#corporateContractsClientsRepresentativeForm-status-field');
            var $email = this.$('#corporateContractsClientsRepresentativeForm-email-field');

            return {
                'name': $name.val(),
                'position': $position.val(),
                'phone': $phone.val(),
                'status': $status.val(),
                'email': $email.val(),
            };
        },

        // =====================================================================
        //  SHARED HELPERS
        // =====================================================================

        _createEditButton: function(name, label) {
            return "<span class='"+ name +"-form btn btn-primary'>" + label + "</span>";
        },

        _displayWrapper: function(wrapperName) {
            if (wrapperName.hasClass("hidden")) {
                wrapperName.removeClass("hidden");
            }
        },

        // =====================================================================
        //  CONTRACT REPRESENTATIVES — disable delete button
        // =====================================================================

        _disableDeleteButton: function() {
            var $deleteButton = this.$('.representative-list .delete-representative-form');
            if (this.representativesContractsCollection.size() === 1) {
                $deleteButton.prop('disabled', true);
                $deleteButton.addClass('disabled');
            } else if (this.representativesContractsCollection.size() > 1) {
                $deleteButton.prop('disabled', false);
                $deleteButton.removeClass('disabled');
            }
        },

        // =====================================================================
        //  CLIENT CONTRACT REPRESENTATIVES — disable delete button
        // =====================================================================

        _disableClientDeleteButton: function() {
            var $deleteButton = this.$('.representativeClients-list .delete-client-representative-form');
            if (this.representativesClientContractsCollection.size() === 1) {
                $deleteButton.prop('disabled', true);
                $deleteButton.addClass('disabled');
            } else if (this.representativesClientContractsCollection.size() > 1) {
                $deleteButton.prop('disabled', false);
                $deleteButton.removeClass('disabled');
            }
        },

        // =====================================================================
        //  CONTRACT REPRESENTATIVES — render row
        // =====================================================================

        /**
         * Method that renders the rows for representatives
         *
         * @param {Object} model - The model for the collection
         * @param {bool} remove - If true, the action is removal of rows
         * @private
         * @return {undefined}
         */
        _renderRepresentativeRow: function(model, remove) {
            var $wrapperName = this.$('.representative-list');

            remove = _.isUndefined(remove) ? false : remove;
            var id = model.get('id') ? model.get('id') : model.cid;

            // General elements
            var $tableName = this.$('#corporateContractsRepresentativeForm-list-field');
            var $row = $tableName.find('tbody tr[data-id="' + id + '"]');
            var isEdit = !!$row.length;

            if( remove ){
                $row.remove();

                // If there are no items in the collection, remove wrapper and table
                if (this.representativesContractsCollection.size() === 0) {
                    this._hideWrapper($wrapperName);
                }
                return;
            }

            if( !isEdit ){
                // Creating dom elements
                var editButtonLabel = Translator.trans('js.btn_edit');
                var $editButton = this._createEditButton('edit-representative', editButtonLabel);
                var $deleteButton = '<div class="delete-representative-form btn"><i class="fa fa-trash-o"></i></div>';

                // Displaying table wrapper
                this._displayWrapper($wrapperName);

                $row = $('<tr>')
                    .attr("data-id", id);

                // Name
                $('<td>')
                    .text(model.get('name'))
                    .appendTo($row);

                // Position
                $('<td>')
                    .text(model.get('position'))
                    .appendTo($row);

                // Phone number
                $('<td>')
                    .text(model.get('phoneNumber'))
                    .appendTo($row);

                // Email
                $('<td>')
                    .text(model.get('email'))
                    .appendTo($row);

                // Actions
                $('<td>')
                    .append($editButton)
                    .append($deleteButton)
                    .appendTo($row);

                // Appending table elements to table
                $tableName.find("tbody").append($row);
            } else {

                $row.find('td:eq(0)').text(model.get('name'));
                $row.find('td:eq(1)').text(model.get('position'));
                $row.find('td:eq(2)').text(model.get('phoneNumber'));
                $row.find('td:eq(3)').text(model.get('email'));
                $row.attr({
                    "data-id": id
                });
            }
            this._disableDeleteButton();
        },

        // =====================================================================
        //  CLIENT CONTRACT REPRESENTATIVES — render row
        // =====================================================================

        /**
         * Method that renders the rows for client representatives
         *
         * @param {Object} model - The model for the collection
         * @param {bool} remove - If true, the action is removal of rows
         * @private
         * @return {undefined}
         */
        _renderClientRepresentativeRow: function(model, remove) {
            var $wrapperName = this.$('.representativeClients-list');

            remove = _.isUndefined(remove) ? false : remove;
            var id = model.get('id') ? model.get('id') : model.cid;

            // General elements
            var $tableName = this.$('#corporateContractsClientsRepresentativeForm-list-field');
            var $row = $tableName.find('tbody tr[data-id="' + id + '"]');
            var isEdit = !!$row.length;

            if( remove ){
                $row.remove();

                // If there are no items in the collection, remove wrapper and table
                if (this.representativesClientContractsCollection.size() === 0) {
                    this._hideWrapper($wrapperName);
                }
                return;
            }

            if( !isEdit ){
                // Creating dom elements
                var editButtonLabel = Translator.trans('js.btn_edit');
                var $editButton = this._createEditButton('edit-client-representative', editButtonLabel);
                var $deleteButton = '<div class="delete-client-representative-form btn"><i class="fa fa-trash-o"></i></div>';

                // Displaying table wrapper
                this._displayWrapper($wrapperName);

                $row = $('<tr>')
                    .attr("data-id", id);

                // Name
                $('<td>')
                    .text(model.get('name'))
                    .appendTo($row);

                // Position
                $('<td>')
                    .text(model.get('position'))
                    .appendTo($row);

                // Phone number
                $('<td>')
                    .text(model.get('phoneNumber'))
                    .appendTo($row);

                // Email
                $('<td>')
                    .text(model.get('email'))
                    .appendTo($row);

                // Actions
                $('<td>')
                    .append($editButton)
                    .append($deleteButton)
                    .appendTo($row);

                // Appending table elements to table
                $tableName.find("tbody").append($row);
            } else {

                $row.find('td:eq(0)').text(model.get('name'));
                $row.find('td:eq(1)').text(model.get('position'));
                $row.find('td:eq(2)').text(model.get('phoneNumber'));
                $row.find('td:eq(3)').text(model.get('email'));
                $row.attr({
                    "data-id": id
                });
            }
            this._disableClientDeleteButton();
        },

        // =====================================================================
        //  CONTRACT REPRESENTATIVES — collection event handlers
        // =====================================================================

        _onRepresentativesContractsCollectionAdd: function (model) {
            this._renderRepresentativeRow(model);
        },

        _onRepresentativesContractsCollectionRemove: function(model){
            this._renderRepresentativeRow(model, true);
        },

        _onRepresentativesContractsCollectionReset: function(){
            this.$('.representative-list').addClass('hidden');
            this.$('#corporateContractsRepresentativeForm-list-field tbody').empty();
        },

        _onRepresentativesContractsCollectionChange: function(model) {
            this._renderRepresentativeRow(model);
        },

        // =====================================================================
        //  CLIENT CONTRACT REPRESENTATIVES — collection event handlers
        // =====================================================================

        _onRepresentativesClientContractsCollectionAdd: function (model) {
            this._renderClientRepresentativeRow(model);
        },

        _onRepresentativesClientContractsCollectionRemove: function(model){
            this._renderClientRepresentativeRow(model, true);
        },

        _onRepresentativesClientContractsCollectionReset: function(){
            this.$('.representativeClients-list').addClass('hidden');
            this.$('#corporateContractsClientsRepresentativeForm-list-field tbody').empty();
        },

        _onRepresentativesClientContractsCollectionChange: function(model) {
            this._renderClientRepresentativeRow(model);
        },

        // =====================================================================
        //  CONTRACT REPRESENTATIVES — populate + create
        // =====================================================================

        /**
         * Populating the general array with representative data from the form
         *
         * @private
         * @return {object} Object filled with model data
         */
        _populateContractsCollectionData: function() {
            var $data = this._getContractRepresentativesData();

            return {
                repdepcontractsname: $data.name,
                name: $data.name,
                position: $data.position,
                phoneNumber: $data.phone,
                email: $data.email
            };
        },

        _onCreateContractsRepresentative: function () {

            var data = this._populateContractsCollectionData();
            var record = new z.ProjectsContractsRepresentativeModel(data);

            // 1. Unbind modelul principal ÎNAINTE de a valida representative-ul
            Backbone.Validation.unbind(this, {model: this.model});

            // 2. Leagă validarea pe modelul representative
            this._bindValidation(record);

            if(!record.isValid(true)){
                // Re-leagă modelul principal înainte de a ieși
                this._bindValidation();
                return;
            }

            // 3. Re-leagă modelul principal
            this._bindValidation();

            if (this.representativeEditAddId){
                var representatives = this.representativesContractsCollection.get(this.representativeEditAddId);
                representatives.set(record.toJSON());
            } else {
                this.representativesContractsCollection.push(record);
            }

            var addingButtonTitle = Translator.trans('js.btn_add');
            this.$('#corporateContractsRepresentativeForm-add-button').html(addingButtonTitle);

            this.$('.representative-validation-error').addClass('hidden');

            this.representativeEditAddId = undefined;

            this._resetFields("corporateContractsRepresentativeForm");
        },

        // =====================================================================
        //  CLIENT CONTRACT REPRESENTATIVES — populate + create
        // =====================================================================

        /**
         * Populating the general array with client representative data from the form
         *
         * @private
         * @return {object} Object filled with model data
         */
        _populateClientContractsCollectionData: function() {
            var $data = this._getClientContractRepresentativesData();

            return {
                repclicontractsname: $data.name,
                name: $data.name,
                position: $data.position,
                phoneNumber: $data.phone,
                email: $data.email
            };
        },

        _onCreateContractsClientRepresentative: function () {

            var data = this._populateClientContractsCollectionData();
            var record = new z.ProjectsContractsClientRepresentativeModel(data);

            // 1. Unbind modelul principal ÎNAINTE de a valida representative-ul
            Backbone.Validation.unbind(this, {model: this.model});

            // 2. Leagă validarea pe modelul representative
            this._bindValidation(record);

            if(!record.isValid(true)){
                // Re-leagă modelul principal înainte de a ieși
                this._bindValidation();
                return;
            }

            // 3. Re-leagă modelul principal
            this._bindValidation();

            if (this.clientRepresentativeEditAddId){
                var representatives = this.representativesClientContractsCollection.get(this.clientRepresentativeEditAddId);
                representatives.set(record.toJSON());
            } else {
                this.representativesClientContractsCollection.push(record);
            }

            var addingButtonTitle = Translator.trans('js.btn_add');
            this.$('#corporateContractsClientsRepresentativeForm-add-button').html(addingButtonTitle);

            this.$('.representative-validation-error').addClass('hidden');

            this.clientRepresentativeEditAddId = undefined;

            this._resetFields("corporateContractsClientsRepresentativeForm");
        },

        // =====================================================================
        //  CONTRACT REPRESENTATIVES — edit + delete
        // =====================================================================

        _onEditRepresentativeForm: function (e) {

            var $editingButtonTitle = Translator.trans('js.btn_edit');
            this.$('#corporateContractsRepresentativeForm-add-button').html($editingButtonTitle);

            var id = $(e.target).parents('tr').data("id");
            var representatives = this.representativesContractsCollection.get(id);
            this.representativeEditAddId = id;

            this.$('#corporateContractsRepresentativeForm-name-field').val(representatives.get('name'));
            this.$('#corporateContractsRepresentativeForm-position-field').val(representatives.get('position'));
            this.$('#corporateContractsRepresentativeForm-phoneNumber-field').val(representatives.get('phoneNumber'));
            this.$('#corporateContractsRepresentativeForm-email-field').val(representatives.get('email'));
        },

        _onDeleteRepresentativeRow: function(e) {
            var id = $(e.target).parents('tr').attr("data-id");
            this.representativesContractsCollection.remove(id);
            this._resetFields("corporateContractsRepresentativeForm");
            this.representativeEditAddId = undefined;
            this._disableDeleteButton();
        },

        // =====================================================================
        //  CLIENT CONTRACT REPRESENTATIVES — edit + delete
        // =====================================================================

        _onEditClientRepresentativeForm: function (e) {

            var $editingButtonTitle = Translator.trans('js.btn_edit');
            this.$('#corporateContractsClientsRepresentativeForm-add-button').html($editingButtonTitle);

            var id = $(e.target).parents('tr').data("id");
            var representatives = this.representativesClientContractsCollection.get(id);
            this.clientRepresentativeEditAddId = id;

            this.$('#corporateContractsClientsRepresentativeForm-name-field').val(representatives.get('name'));
            this.$('#corporateContractsClientsRepresentativeForm-position-field').val(representatives.get('position'));
            this.$('#corporateContractsClientsRepresentativeForm-phoneNumber-field').val(representatives.get('phoneNumber'));
            this.$('#corporateContractsClientsRepresentativeForm-email-field').val(representatives.get('email'));
        },

        _onDeleteClientRepresentativeRow: function(e) {
            var id = $(e.target).parents('tr').attr("data-id");
            this.representativesClientContractsCollection.remove(id);
            this._resetFields("corporateContractsClientsRepresentativeForm");
            this.clientRepresentativeEditAddId = undefined;
            this._disableClientDeleteButton();
        },

        // =====================================================================
        //  MODEL — attach representatives before save
        // =====================================================================

        /**
         * Method that sets the response in a specific form before saving it to the database
         *
         * @param {Object} model - The vendor model
         * @private
         * @return {undefined}
         */
        _addRepresentativesModel: function(model) {
            var representatives = [];

            this.representativesContractsCollection.each(function(representative){
                representatives.push(representative.toJSON());
            });

            // Setting extra fields representatives on model
            model.set("representatives", representatives);
        },

        /**
         * Method that sets the response in a specific form before saving it to the database
         *
         * @param {Object} model - The vendor model
         * @private
         * @return {undefined}
         */
        _addClientRepresentativesModel: function(model) {
            var representatives = [];

            this.representativesClientContractsCollection.each(function(representative){
                representatives.push(representative.toJSON());
            });

            // Setting extra fields representativesClient on model
            model.set("representativesClients", representatives);
        },


    });

})(window.z = window.z || {});
